<template>
		
            <div class="mt-2">
				
				<b-link href="/register/seller"> <b-img :src="$root.MEDIAPATH+'banners/Strip-Call-Out-PDP-Banner-01.png'" class="w-100"></b-img></b-link>
                
            </div>
        
            <!--<b-container class="bannerpro">
                <b-row class="align-items-center">
                    <b-col cols lg="6" class="font-weight-bold">
                        <p class="line-1 m-0">
                            LIST YOUR BRAND
                        </p>
                         <p class="line-2 m-0">
                            OPEN YOUR OWN STORE IN JUST 5 MINUTES
                        </p>
                         <p class="line-3 m-0">
                           START SELLING FROM TODAY
                        </p>
                    </b-col>
                    <b-col cols="2"> 
						&nbsp;
                    </b-col>
                    <b-col cols lg="4" class=" d-flex align-items-center justify-content-center p-0" >
                        <b-button size="lg" class="register" >Register Now</b-button>
                    </b-col>
                </b-row>
            </b-container> -->
        
    
</template>
<script>
export default {

}
</script>
<style lang="scss">
.bannerpro{
	background: #A585BC;
    color: black;
	.line-1, .line-2, .line-3 {
        font-size: 10px;
    }
    .line-2 {
       font-size: 15px;
		color: white;
		letter-spacing: 2px;
		line-height: 16px;
    }
    .line-3 {
        float: left;
		
    }
    .register {
        background: #7954A1 !important;
        color: white !important;
		font-size: 11px;
    }

}
   
    
</style>